import arrowBig from "./arrow-big.svg";
import initial from "./group-10-copy-3.svg";
import withIntersect from "./group-10-copy-4.svg";
import result from "./group-10-copy-5.svg";
import geometryWithoutInfo from "./group-10-copy-6.svg";
import resultOutside from "./group-10-copy-7.svg";
import intersectOutside from "./group-10-copy-8.svg";

export const images = {
  initial,
  geometryWithoutInfo,
  withIntersect,
  result,
  arrowBig,
  resultOutside,
  intersectOutside,
};
